var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import cls from 'classnames';
import { RadioGroup } from 'rcm-mobile';
import './style/index.scss';
/**
 * @author sayll
 * @version 0.0.1
 */
export default class Radio extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            checked: props.checked
        };
    }
    render() {
        const _a = this.props, { prefixCls, className, children, disabled, readOnly, onClick } = _a, resetProps = __rest(_a, ["prefixCls", "className", "children", "disabled", "readOnly", "onClick"]);
        return (<label className={cls(`${prefixCls}-wrapper`, className, {
            [`${prefixCls}-checked`]: this.state.checked,
            [`${prefixCls}-disabled`]: disabled,
            [`${prefixCls}-readonly`]: readOnly
        })} onClick={e => this.handleClick(e)} {...resetProps}>
        <span className={prefixCls}/>
        {children}
      </label>);
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.checked !== prevState.checked) {
            return { checked: nextProps.checked };
        }
        return null;
    }
    /**
     * RadioGroup组件
     * @public
     * */
    static Group(props) {
        return <RadioGroup {...props}/>;
    }
    get value() {
        return this.props.value;
    }
    handleClick(e) {
        const { onClick, disabled, readOnly } = this.props;
        if (disabled || readOnly)
            return;
        this.setState((state) => ({ checked: !state.checked }));
        onClick && onClick(e);
    }
}
Radio.defaultProps = {
    prefixCls: 'x-radio',
    checked: true,
    disabled: false,
    readOnly: false
};
